import { useNavigate, useLocation } from 'react-router-dom'
import { ReactNode } from 'react'

interface SmoothScrollLinkProps {
  href: string
  children: ReactNode
  className?: string
  onClick?: () => void
}

const SmoothScrollLink = ({
  href,
  children,
  className,
  onClick,
}: SmoothScrollLinkProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    // Check if it's an anchor link (starts with /# or #)
    const isAnchorLink = href.includes('#')

    if (isAnchorLink) {
      const targetId = href.split('#')[1]
      const basePath = href.split('#')[0] || '/'

      const scrollToElement = () => {
        const element = document.getElementById(targetId)
        if (element) {
          const headerOffset =
            document.querySelector('.sticky')?.getBoundingClientRect().height ??
            0
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY
          window.scrollTo({
            top: elementPosition - headerOffset - 12,
            behavior: 'smooth',
          })
        }
      }

      // If we're on a different page, navigate first
      if (location.pathname !== basePath && basePath !== '') {
        navigate(basePath)
        setTimeout(scrollToElement, 100)
      } else {
        scrollToElement()
      }
    } else {
      // Regular navigation — scroll to top after route change
      navigate(href)
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 50)
    }

    onClick?.()
  }

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}

export default SmoothScrollLink
